import React from 'react';
import {TFunction} from 'i18next';
import {TemplateItem, TemplateStructure} from '../../types/templateStructure';
import {renderTemplateItem} from '../../utils/renderTemplateItem';

interface WhatsAppTemplateStructureEditorProps {
    structure: TemplateStructure;
    handleItemChange: (index: number, updatedItem: TemplateItem) => void;
    setLastFocusedEditable: (element: HTMLElement | null) => void;
    updateSavedCursorOffset: () => void;
    variables: Record<string, unknown>;
    t: TFunction;
}

function WhatsAppTemplateStructureEditor({
    structure,
    handleItemChange,
    setLastFocusedEditable,
    updateSavedCursorOffset,
    variables,
    t,
}: WhatsAppTemplateStructureEditorProps) {
    return (
        <>
            {structure?.map((item: TemplateItem, index: number) => renderTemplateItem({
                item,
                index,
                handleItemChange,
                setLastFocusedEditable,
                updateSavedCursorOffset,
                variables,
                t,
            }))}
        </>
    );
}

export default WhatsAppTemplateStructureEditor;
